import {  useEffect, useState } from "react";
import { Text, TableContainer, Tr, Td, Th, Table, Thead, Tbody, Icon, Heading, Box, useToast, Tooltip, Button, Modal, ModalOverlay, ModalContent, ModalHeader, CloseButton, ModalBody, ModalFooter, useDisclosure, FormControl, FormLabel, Input, RadioGroup, Radio, Stack, Checkbox, Textarea} from "@chakra-ui/react";
import { DeleteIcon} from '@chakra-ui/icons';
import { EditIcon } from "@chakra-ui/icons";
import createAxiosInstance from "../../../interceptors/useAxiosInterceptors";
import { useSession } from "../../../SessionContext";
import {  useNavigate} from "react-router-dom";
import logout from "../../../services/authService";
import { RiAddLargeFill } from "react-icons/ri";
import {  initSurveyService } from "../../../services/http/surveyHttpService";
import { getExpertsADP } from "../../../services/http/surveyHttpService";
import CreateExpertModal from "./CreateExpertModal";
import { FaFileCsv } from "react-icons/fa6";
import UploadExpertByCsvModal from "./UploadExpertByCsvModal";
import { useTranslation } from "react-i18next";
import UpdateExpertModal from "./UpdateExpertModal";
import { deleteExpertADP } from "../../../services/http/surveyHttpService";
export default function ExpertView (){
  const {t} = useTranslation();
  
  const [value, setValue] = useState("");

  const [formDataInputUpdateExpert, setFormDataInputUpdateExpert] = useState({});

  const [experts, setExperts] = useState([]);
  const toast = useToast();
  const [message, setMessage] = useState("");
  const { updateSessionData, clearSessionData} = useSession();

  const navigate = useNavigate();

  const { isOpen: isCreateExpertModalOpen, onOpen: onCreateExpertModalOpen, onClose: onCreateExpertModalClose } = useDisclosure();
  const { isOpen: isUpdateExpertModalOpen, onOpen: onUpdateExpertModalOpen, onClose: onUpdateExpertModalClose } = useDisclosure();

  const { isOpen: isUploadExpertByCsvModalOpen, onOpen: onUploadExpertByCsvModalOpen, onClose: onUploadExpertByCsvModalClose } = useDisclosure();

  const { isOpen: isOpenModalConfirmDeleteExpert, onOpen: onOpenModalConfirmDeleteExpert, onClose: onCloseModalConfirmDeleteExpert } = useDisclosure();



  const [payloadUploadDashboard, setPayloadUploadDashboard] = useState({});

  const axiosInstance = createAxiosInstance(async (axiosInstance)=> {

    logout(t, clearSessionData,navigate,toast,axiosInstance)
  });

  initSurveyService(t, toast, axiosInstance)
  /*
  Carica le dashboards in una tabella ogni volta che viene caricata la pagina (useEffect) interrogando l'endpoint con 
  l'invio di un json contente il token di identificaione, l'username dellutente e una costante caseType per indicare al backend 
  di quale chiamata si tratta e quali paremetri deve inviarci. Per consultare i case type consultare il file CaseTypeConstant.js  
  */
  useEffect(() => {
    // Fai la chiamata API una sola volta al montaggio del componente
    getExpertsADP({username: sessionStorage.getItem("username")}).then(res => {
    
      if (res != null && res.experts != null && res.experts.length > 0) {
        setExperts(res.experts);
      }

    });
  }, []); 


const [searchCheckedCategories, setSearchCheckedCategories] = useState(
  [])



  const handleCategoryChange = (category) => {
    setSearchCheckedCategories((prevCategories) => {
      // Controlla se la categoria è già selezionata
      const isCategoryChecked = prevCategories.includes(category);
  
      // Se è già selezionata, la rimuoviamo; altrimenti, la aggiungiamo
      const updatedCategories = isCategoryChecked
        ? prevCategories.filter((c) => c !== category)  // Rimuovi la categoria
        : [...prevCategories, category];  // Aggiungi la categoria
  
      // Aggiorna il payload con le categorie modificate
      setPayloadUploadDashboard((prev) => ({
        ...prev,
        categories: updatedCategories,  // Usa le categorie aggiornate
      }));
  
      return updatedCategories;  // Ritorna l'array aggiornato
    });
  };




      const submitDashboard = async () => {
        if(payloadUploadDashboard.dashboardName != null && payloadUploadDashboard.dashboardName.length >0 &&
          payloadUploadDashboard.linkDashboard != null && payloadUploadDashboard.linkDashboard.length >0 &&
          
          payloadUploadDashboard.visibility != null && payloadUploadDashboard.categories.length > 0 &&
          payloadUploadDashboard.description != null && payloadUploadDashboard.description.length >0
        ) {
        try{
         
           }

      
      catch(error) {
        toast({
          title: t('toastMsg.error'),
          description: String(error),
          position: "top",
          status: 'warning',
          duration: 4000,
          isClosable: true});
    }



  }
      


      }
      
      const [openDashboardModal, setOpenDashboardModal] = useState(false);
      const [linkDashboard, setLinkDashboard] = useState("")

      const onCloseDashboardViewModal = () => {
        setOpenDashboardModal(false)
      }

      /*const openDashboardViewModal = (link) => {
      setLinkDashboard(link)
      setOpenDashboardModal(true)
      }*/

      const openDashboardViewModal = (link) => {
        //const encodedLink = encodeURIComponent(link);
        navigate('/iframe', { state: { link } });
        }


      
    return(
        <>

        <CreateExpertModal
        
        isOpen={isCreateExpertModalOpen}
        onClose={onCreateExpertModalClose}
        onSaveExpert={()=> {
          getExpertsADP({username: sessionStorage.getItem("username")}).then(res => {
           
            if (res != null && res.experts != null && res.experts.length > 0) {
              setExperts(res.experts);
            }
          }).catch(e=> {

            return
          });
        }}
        
        ></CreateExpertModal>

        <UpdateExpertModal
        
        isOpen={isUpdateExpertModalOpen}
        onClose={onUpdateExpertModalClose}
        formDataInput={{
          name: formDataInputUpdateExpert.name,
          surname: formDataInputUpdateExpert.surname,
          email: formDataInputUpdateExpert.email,
          expertId: formDataInputUpdateExpert.expert_id
      }}
        refreshExpertData={()=> {
          getExpertsADP({username: sessionStorage.getItem("username")}).then(res => {
            console.log(res);
            if (res != null && res.experts != null && res.experts.length > 0) {
              setExperts(res.experts);
            }
          });
        }}
        
        ></UpdateExpertModal>



        <UploadExpertByCsvModal
        
        refreshExpertData={
          (()=>{
            getExpertsADP({username: sessionStorage.getItem("username")}).then(res => {
    
              if (res != null && res.experts != null && res.experts.length > 0) {
                setExperts(res.experts);
              }
        
            });
        })}
        isOpen={isUploadExpertByCsvModalOpen}
        onClose={onUploadExpertByCsvModalClose}
        >

        </UploadExpertByCsvModal>


        <Modal onClose={onCloseModalConfirmDeleteExpert} isOpen={isOpenModalConfirmDeleteExpert} isCentered closeOnOverlayClick={false} >
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>   {t('survey.tableExpert.doYouConfirmToRemoveTheExpert')} </ModalHeader>
              <ModalBody></ModalBody>
              <ModalFooter>
                <Button colorScheme='green' mr={3} onClick={()=> {
                  
                  deleteExpertADP(t, formDataInputUpdateExpert.expert_id).then((res)=> {
                  onCloseModalConfirmDeleteExpert()
                  toast({
                    title: "",
                    description: res.message,
                    position: "bottom",
                    status: res.status =="404" ? "error": "info",
                    duration: 2000,
                    isClosable: true});

                    
                  setExperts((prevExperts) =>
                    prevExperts.filter((expert) => expert.expert_id !== formDataInputUpdateExpert.expert_id)
                  );
                    
                  }

                  )
                }}>
                   {t('survey.tableGroup.yes')}
                </Button>
                <Button colorScheme='red' onClick={onCloseModalConfirmDeleteExpert}>
                  No
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

        <Box
  alignItems="center"
  justifyContent="flex-end"
  display="flex"
  color="rgba(11,78,90,255)"
  bgColor="#f6f3ec"
  padding="5px"
>
  <Heading marginRight="auto">Experts</Heading>

  <Box display="flex" gap="8px">
<Tooltip label={t('toolTip.tooltipSurvey.expertCatalog.header.createExpert')} placement="bottom">
    <Button
      color="rgba(11,78,90,255)"
      bgColor="#f6f3ec"
      h="100%"
      onClick={() => {
        onCreateExpertModalOpen();
      }}
    >
      <Icon boxSize={4} mr={1} strokeWidth={1} as={RiAddLargeFill} />
      {t('survey.createExpert')}
    </Button>
</Tooltip>
<Tooltip label={t('toolTip.tooltipSurvey.expertCatalog.header.createExpertCsv')} placement="bottom"> 

    <Button
      color="rgba(11,78,90,255)"
      bgColor="#f6f3ec"
      h="100%"
      onClick={() => {
        onUploadExpertByCsvModalOpen();
      }}
    >
      <Icon mr={1} as={FaFileCsv} />
      {t('survey.createExpertsFromCsv')}
    </Button>
</Tooltip>
  </Box>
</Box>
        <Box bgColor={"white"}   overflowY="auto" direction="column" h="100%" w="100%" boxShadow="lg">
        <TableContainer px={"1%"} paddingTop={"1%"} >
        
        <Table variant='striped' >
    
        <Thead bgColor="#0888BE">
      <Tr>
      <Th whiteSpace="normal" wordBreak="break-word" minW="150px" w="10%" color="white">
          {t('survey.tableExpert.consensus')}
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="150px" w="15%" color="white">
          {t('survey.tableExpert.name')}
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="150px" w="15%" color="white">
          {t('survey.tableExpert.surname')}
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="120px" w="10%" color="white">
          {t('survey.tableExpert.role')}
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="150px" w="20%" color="white">
          Skilled_In1
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="150px" w="20%" color="white">
        Skilled_In2
        </Th>
       
        <Th whiteSpace="normal" wordBreak="break-word" minW="150px" w="10%" color="white">
        Skilled_In3
        </Th>
        <Th whiteSpace="normal" wordBreak="break-word" minW="120px" w="20%" color="white">
          H_Index
        </Th>
       
        <Th color="white" minW="120px" w="20%">{t('survey.tableExpert.actions')}</Th>
      </Tr>
    </Thead>
     
      <Tbody  maxHeight="100%" overflowY="auto" borderWidth={1} boxShadow="lg">
      {experts.length > 0 ? 
      
    (experts.map(item=> (


    <Tr>
       <Td  whiteSpace={"normal"} wordBreak={"break-word"}> {item.has_consensus ? t('survey.tableExpert.yes'): "No"}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}> {item.name}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.surname}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.role}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.skilled_in1}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.skilled_in2}</Td>

      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.skilled_in3}</Td>
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>{item.h_index}</Td>
 
      <Td  whiteSpace={"normal"} wordBreak={"break-word"}>

<Tooltip label={t('toolTip.tooltipSurvey.expertCatalog.tableActions.updateExpert')} placement="bottom">
  <Icon ml={"10%"}
    as={EditIcon} // Sostituisci con l'icona corretta per aggiornare
    onClick={() =>{ 
      setFormDataInputUpdateExpert(item)
      onUpdateExpertModalOpen();
      

      

    }}
    _hover={{ color: "blue.200" }}
    cursor="pointer"
  />
</Tooltip>

<Tooltip label={t('toolTip.tooltipSurvey.expertCatalog.tableActions.deleteExpert')} placement="bottom">
  <Icon ml={"10%"}
    as={DeleteIcon} // Sostituisci con l'icona corretta per aggiornare
    onClick={() =>{ 
      setFormDataInputUpdateExpert(item)
      onOpenModalConfirmDeleteExpert()

    }}
    _hover={{ color: "blue.200" }}
    cursor="pointer"
  />
</Tooltip>




 

      </Td>
    </Tr>))): (<Tr><Text fontSize={"lg"} fontWeight={"bold"}>{message}</Text></Tr>)}

      </Tbody>
      
     
    </Table> 
  </TableContainer>
  </Box> 



                            </>



    )


}






